/** IT training: what the index and the lesson page share. */

import {
  Icon,
  type IconComponent,
  KeyRound,
  Languages,
  Route,
  Ticket,
  Wrench,
} from "@norican/icons";
import { Typography } from "@norican/react";
import { useMemo } from "react";

import { useLanguage, useT } from "@/i18n";

import type { TrainingTopic } from "./lib/lessons";

export const TOPIC_ICONS: Readonly<Record<TrainingTopic, IconComponent>> = {
  tickets: Ticket,
  routing: Route,
  access: KeyRound,
  tools: Wrench,
};

/** "8 Oct 2026" in the reader's locale, for a content date (YYYY-MM-DD, no time zone). */
export function useContentDate(): (date: string) => string {
  const { locale } = useLanguage();
  return useMemo(() => {
    const format = new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    });
    return (date: string) => {
      const parsed = new Date(`${date}T00:00:00Z`);
      return Number.isNaN(parsed.getTime()) ? date : format.format(parsed);
    };
  }, [locale]);
}

/** "English only for now." — lessons are not translated yet. */
export function EnglishOnlyNote() {
  const { t } = useT("tickets");
  return (
    <Typography as="p" variant="body-sm" tone="muted" className="inline-flex items-center gap-2">
      <Icon icon={Languages} size="sm" />
      <span>{t("itAdmin.training.englishOnly")}</span>
    </Typography>
  );
}
